import React from 'react';
import PropTypes from 'prop-types';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';
import AccountsTableInner from './TableInner';
import HeaderShadow from '../HeaderShadow';

const AccountsHeading = (props) => {
  const {
    children, className, title, editLink, editTooltip,
  } = props;

  return (
    <div className={`accounts-heading ${className}`}>
      {title !== '' && (
        <AccountsTableInner>
          <h3>
            {title}
            {editLink && (<EditButtonLink
              title={editTooltip}
              to={editLink}
            />)}
          </h3>
        </AccountsTableInner>
      )}
      {children !== '' && (
        <HeaderShadow>
          <div className="labels">
            <AccountsTableInner>{children}</AccountsTableInner>
          </div>
        </HeaderShadow>
      )}
    </div>
  );
};

AccountsHeading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
  editLink: PropTypes.string,
  editTooltip: PropTypes.string,
};

AccountsHeading.defaultProps = {
  className: '',
  title: '',
  children: '',
  editLink: '',
  editTooltip: '',
};

export default AccountsHeading;
